/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getWards } from 'app/entities/ward/ward.reducer';
import { getEntities as getDepartments } from 'app/entities/department/department.reducer';
import { createEntity, getEntity, reset, updateEntity } from './department-ward.reducer';

export const DepartmentWardUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const wards = useAppSelector(state => state.ward.entities);
  const departments = useAppSelector(state => state.department.entities);
  const departmentWardEntity = useAppSelector(state => state.departmentWard.entity);
  const loading = useAppSelector(state => state.departmentWard.loading);
  const updating = useAppSelector(state => state.departmentWard.updating);
  const updateSuccess = useAppSelector(state => state.departmentWard.updateSuccess);

  const handleClose = () => {
    navigate(`/department-ward${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getWards({}));
    dispatch(getDepartments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.skillLevel !== undefined && typeof values.skillLevel !== 'number') {
      values.skillLevel = Number(values.skillLevel);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...departmentWardEntity,
      ...values,
      ward: wards.find(it => it.id.toString() === values.ward?.toString()),
      department: departments.find(it => it.id.toString() === values.department?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...departmentWardEntity,
          ward: departmentWardEntity?.ward?.id,
          department: departmentWardEntity?.department?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.departmentWard.home.createOrEditLabel" data-cy="DepartmentWardCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.departmentWard.home.createOrEditLabel">Create or edit a DepartmentWard</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="department-ward-id"
                  label={translate('tinyMedicRestApp.departmentWard.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.skillLevel')}
                id="department-ward-skillLevel"
                name="skillLevel"
                data-cy="skillLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.active')}
                id="department-ward-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.cursor')}
                id="department-ward-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.lastUpdate')}
                id="department-ward-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.microSec')}
                id="department-ward-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentWard.timestampEntry')}
                id="department-ward-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="department-ward-ward"
                name="ward"
                data-cy="ward"
                label={translate('tinyMedicRestApp.departmentWard.ward')}
                type="select"
              >
                <option value="" key="0" />
                {wards
                  ? wards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="department-ward-department"
                name="department"
                data-cy="department"
                label={translate('tinyMedicRestApp.departmentWard.department')}
                type="select"
              >
                <option value="" key="0" />
                {departments
                  ? departments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/department-ward" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DepartmentWardUpdate;
